const DataLayer = {
  /**
   * Pushes a "virtualPageView" event to `window.dataLayer`.
   *
   * Sets `window.dataLayer` to an empty array if undefined.
   * @param {Object} options Details of the virtual pageview to send.
   * @param {string} options.path Path of the URL for the pageview.
   * @param {string} options.title Title for the pageview.
   */
  sendVirtualPageView({ path, title }) {
    if (typeof window.dataLayer === 'undefined') {
      window.dataLayer = [];
    }

    const location = `${process.env.ROOT_URL}/virtual${path}`;

    window.dataLayer.push({
      event: 'virtualPageView',
      virtualPage: {
        location,
        title,
      },
    });
  },

  sendAnalyticsEvent({ category, action, label }) {
    if (typeof window.dataLayer === 'undefined') {
      window.dataLayer = [];
    }

    window.dataLayer.push({
      event: 'eventTracking',
      category: category,
      action: action,
      label: label,
    });
  },
};

export default DataLayer;
